var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQRcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,294.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,325.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,356.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,387.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,418.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,449.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,480.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 496,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,511.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,542.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 558,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,573.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 589,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,604.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,635.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 279,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,294.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,666.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,697.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 713,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,728.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 434,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,449.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 372,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,387.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 496,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,511.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 558,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,573.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 310,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,325.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 465,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,480.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 682,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,697.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 713,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,728.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 341,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,356.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 403,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,418.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 527,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,542.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 589,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,604.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 620,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,635.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 651,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,666.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,883.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,263.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 124,
    width: 93,
    height: 93,
    transform: "rotate(0,170.5,170.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,759.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 775,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,790.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,821.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 837,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,852.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 868,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,883.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 899,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,914.5,263.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 62,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,77.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 93,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,108.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 124,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,139.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 155,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 186,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,201.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 217,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,232.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 930,
    y: 248,
    width: 31,
    height: 31,
    transform: "rotate(0,945.5,263.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 124,
    width: 93,
    height: 93,
    transform: "rotate(90,852.5,170.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,77.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,108.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,139.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,170.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,201.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,232.5,945.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 744,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,759.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 775,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,790.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 806,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,821.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 837,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,852.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 868,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,883.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 899,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,914.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 930,
    width: 31,
    height: 31,
    transform: "rotate(0,263.5,945.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 806,
    width: 93,
    height: 93,
    transform: "rotate(-90,170.5,852.5)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 1024,
    width: 1024,
    clipPath: "url('#clip-path-background-color')",
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    height: 899,
    width: 899,
    clipPath: "url('#clip-path-dot-color')",
    fill: "#000000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 124,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#000000"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 744,
    y: 62,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#000000"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 806,
    y: 124,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#000000"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 744,
    height: 217,
    width: 217,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#000000"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 124,
    y: 806,
    height: 93,
    width: 93,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQRcode);
export default __webpack_public_path__ + "static/media/QRcode.ef4101ee19d31170d2e4bc5c1de8a92d.svg";
export { ForwardRef as ReactComponent };